import PageIntro from "@/components/PageIntro";

const content = {
  privacy: {
    title: "Privacy Policy",
    body: "This is an editable policy placeholder for the preview build. ELA will supply the approved privacy policy before launch. Member data—including private feedback, journals and uploaded photos—is stored securely and kept private by default. Members can manage permissions and request export or deletion.",
  },
  terms: {
    title: "Terms",
    body: "This is an editable policy placeholder for the preview build. ELA will supply the approved participation terms before launch. Joining the community is free; individual programme costs, shipping terms and eligibility are disclosed before an application opens. Membership does not guarantee a product.",
  },
};

export default function PolicyPage({ kind = "privacy" }) {
  const c = content[kind] || content.privacy;
  return (
    <div>
      <PageIntro eyebrow="Policies" title={c.title} />
      <section className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 pb-24">
        <p className="text-charcoal/75 leading-relaxed">{c.body}</p>
      </section>
    </div>
  );
}
